import type { TmWrappers } from '@/wrappers'
import ChatMessage from '@/data/models/domain/chats/ChatMessage'
import SentSmsFull from '@/data/models/domain/SentSmsFull'
import ReceivedSms from '@/data/models/domain/ReceivedSms'
import OutboundCall from '@/data/models/domain/OutboundCall'
import InboundCall from '@/data/models/domain/InboundCall'
import ForwardedCall from '@/data/models/domain/ForwardedCall'
import type { ChatDirection, ChatType } from '@/data/models/domain/chats/types'

export const scheduledMessagesModalId: TmWrappers = 'scheduledMessageModal'

type MessageDetailsModelTypeChatMessage = typeof ChatMessage
export const isModelTypeChatMessage = (
  modelType: MessageDetailsModelType,
): modelType is MessageDetailsModelTypeChatMessage => {
  return modelType.entity === ChatMessage.entity
}

type MessageDetailsModelTypeSentSmsFull = typeof SentSmsFull
export const isModelTypeSentSmsFull = (
  modelType: MessageDetailsModelType,
): modelType is MessageDetailsModelTypeSentSmsFull => {
  return modelType.entity === SentSmsFull.entity
}

type MessageDetailsModelTypeReceivedSms = typeof ReceivedSms
export const isModelTypeReceivedSms = (
  modelType: MessageDetailsModelType,
): modelType is MessageDetailsModelTypeReceivedSms => {
  return modelType.entity === ReceivedSms.entity
}

type MessageDetailsModelTypeOutboundCall = typeof OutboundCall
export const isModelTypeOutboundCall = (
  modelType: MessageDetailsModelType,
): modelType is MessageDetailsModelTypeOutboundCall => {
  return modelType.entity === OutboundCall.entity
}

type MessageDetailsModelTypeInboundCall = typeof InboundCall
export const isModelTypeInboundCall = (
  modelType: MessageDetailsModelType,
): modelType is MessageDetailsModelTypeInboundCall => {
  return modelType.entity === InboundCall.entity
}

type MessageDetailsModelTypeForwardedCall = typeof ForwardedCall
export const isModelTypeForwardedCall = (
  modelType: MessageDetailsModelType,
): modelType is MessageDetailsModelTypeForwardedCall => {
  return modelType.entity === ForwardedCall.entity
}

type MessageDetailsModelType =
  | MessageDetailsModelTypeChatMessage
  | MessageDetailsModelTypeSentSmsFull
  | MessageDetailsModelTypeReceivedSms
  | MessageDetailsModelTypeOutboundCall
  | MessageDetailsModelTypeInboundCall
  | MessageDetailsModelTypeForwardedCall

export type MessageDetailsModalParamsBase<T extends ChatType> = {
  id: string
  modelType: MessageDetailsModelType
  chatType?: T
  direction?: ChatDirection
  contactId?: number | null
  showActions?: boolean
}

export type MessageDetailsModalParamsWhatsApp = {
  chatId: string
  whatsAppUpdateChatCallback: () => Promise<void>
} & MessageDetailsModalParamsBase<ChatType.WhatsAppBusiness>

export type MessageDetailsModalParams =
  | MessageDetailsModalParamsBase<Exclude<ChatType, ChatType.WhatsAppBusiness>>
  | MessageDetailsModalParamsWhatsApp
